import { render, staticRenderFns } from "./AIChat.vue?vue&type=template&id=c7887b48&scoped=true&"
import script from "./AIChat.vue?vue&type=script&lang=js&"
export * from "./AIChat.vue?vue&type=script&lang=js&"
import style0 from "./AIChat.vue?vue&type=style&index=0&id=c7887b48&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7887b48",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
